"use strict";
var hlp = require('common/helpers');
var Menu = require('../helpers/menu');
var archivnrsCtrl = require('./archivnrsCtrl');
var MENUENTRIES = require('../helpers/menuentries');
var fieldEntryArchivnrCtrl = function($scope, $uibModal, $sce, $http) {
  var init = function() {
    initMenu();
  };
  var initMenu = function() {
    var menu = new Menu();
    var group = menu.createGroup();
    if ($scope.schema.type == "archivnr") {
      group = menu.createGroup();
      group.addItem(MENUENTRIES.search, function() {
        $scope.showArchivnrs();
      }, true);
    }
    group = menu.createGroup();
    group.addItem(MENUENTRIES.copyall, function() {
      $scope.setEnsemble($scope.entry, false);
    }, function() {
      if ($scope.entry.value.length > 0) {
        return true;
      }
      return false;
    });
    group.addItem(MENUENTRIES.copyempty, function() {
      $scope.setEnsemble($scope.entry, true);
    }, function() {
      if ($scope.entry.value.length > 0) {
        return true;
      }
      return false;
    });
    if (hlp.isSet($scope.schema.flags)) {
      group = menu.createGroup();
      if ($scope.schema.flags.primary) {
        group.addItem(MENUENTRIES.primary, function() {
          $scope.toggleFlag($scope.entry, 'primary');
        }, true);
      }
      if ($scope.schema.flags.outdated) {
        group.addItem(MENUENTRIES.outdated, function() {
          $scope.toggleFlag($scope.entry, 'outdated');
        }, true);
      }
      if ($scope.schema.flags.hidden) {
        group.addItem(MENUENTRIES.hidden, function() {
          $scope.toggleFlag($scope.entry, 'hidden');
        }, true);
      }
      group = menu.createGroup();
      if ($scope.schema.flags.detail) {
        group.addItem(MENUENTRIES.detail, function() {
          $scope.toggleFlag($scope.entry, 'detail');
        }, true);
      }
      if ($scope.schema.flags.total) {
        group.addItem(MENUENTRIES.total, function() {
          $scope.toggleFlag($scope.entry, 'total');
        }, true);
      }
    }
    if ($scope.schema.multiple) {
      group = menu.createGroup();
      group.addItem(MENUENTRIES.add, function() {
        $scope.addEntry();
      }, true);
      group.addItem(MENUENTRIES.remove, function() {
        $scope.removeEntry($scope.entry);
      }, true);
    }
    menu.calcShow();
    $scope.menu = menu;
  };
  $scope.showArchivnrs = function() {
    var modal = $uibModal.open({
      templateUrl: 'documenteditor/templates/archivnrs.ng.html',
      backdrop: 'static',
      controller: archivnrsCtrl,
      size: 'lg',
      resolve: {archivnrsParams: function() {
          if (!hlp.isSet($scope.entry.value)) {
            $scope.entry.value = "";
          }
          return {archivnr: $scope.entry.value};
        }}
    });
    modal.result.then(function(value) {
      $scope.entry.value = value.archivnr[0];
      $scope.menu.calcShow();
    });
  };
  $scope.getEnsembles = function() {
    var query = $scope.entry.value;
    return $http.get('/api/ensemble/autocomplete.json?query=' + query).then(function(response) {
      return response.data.works;
    });
  };
  init();
};
fieldEntryArchivnrCtrl.$inject = ['$scope', '$uibModal', '$sce', '$http'];
module.exports = fieldEntryArchivnrCtrl;
